// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_2b-2";
export var blackBorderOnHover = "_2b-7";
export var cell = "_2b-6";
export var cellContainer = "_2b-3";
export var checked = "_2b-8";
export var disabled = "_2b-5";
export var featuredIconCellContainer = "_2b-9";
export var featuredIconTextContainer = "_2b-b";
export var featuredIconWrapper = "_2b-a";
export var noBorder = "_2b-c";
export var orangeSelectedRow = "_50-3";
export var overflowableText = "_2b-0";
export var overflowableTextContainer = "_2b-1";
export var row = "_1o-0";
export var rowCheckboxCell = "_2b-4";
export var selectableTable = "_50-2";